import React, { useEffect } from "react";
import { Outlet, useLocation, useNavigationType } from "react-router-dom";
import MyNavbar from "./MyNavbar";
import MyFooter from "./MyFooter";
import { Container } from "react-bootstrap";

const Layout = () => {
  const location = useLocation();
  const navigationType = useNavigationType();

  // Scroll restoration intégré ici au lieu du router
  useEffect(() => {
    if (navigationType === "POP") {
      window.scrollTo(0, window.sessionStorage.getItem(`scrollPos_${location.pathname}`) || 0);
    }

    const handleScroll = () => {
      window.sessionStorage.setItem(`scrollPos_${location.pathname}`, window.scrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [location, navigationType]);

  return (
    <div className="d-flex flex-column min-vh-100">
      <MyNavbar />
      <Container className="flex-grow-1 mt-4">
        <Outlet /> {/* Contenu dynamique des pages */}
      </Container>
      <MyFooter />
    </div>
  );
};

export default Layout;
